import { createText, createLine } from './helpers';

export const classicAppreciation = () => ({
  id: 'classic-appreciation',
  name: 'Classic Appreciation',
  thumbnail: '/assets/diploma-templates/01_example.webp',
  data: {
    elements: [
      createText({
        text: 'CERTIFICATE',
        left: 97,
        top: 188,
        fontSize: 85,
        fontFamily: 'Cinzel',
        width: 600
      }),
      createText({
        text: 'OF APPRECIATION',
        left: 222,
        top: 270,
        fontSize: 25,
        fontFamily: 'Lato',
        width: 350
      }),
      createText({
        text: 'proudly presented to',
        left: 247,
        top: 435,
        fontSize: 16,
        fontFamily: 'Sofia Sans Semi Condensed',
        width: 300,
        color: '#353535',
        fontStyle: 'italic',
        fontWeight: '300'
      }),
      createText({
        text: '{learner_name}',
        left: 97,
        top: 529,
        fontSize: 82,
        fontFamily: 'Great Vibes',
        width: 600
      }),
      createLine({ left: 154, top: 605, width: 486 }),
      createText({
        text: 'for completing the course',
        left: 197,
        top: 635,
        fontSize: 16,
        fontFamily: 'Sofia Sans Semi Condensed',
        fontStyle: 'italic',
        fontWeight: '300',
        width: 400,
        color: '#353535',
      }),
      createText({
        text: '{program_name}',
        left: 60,
        top: 676,
        fontSize: 25,
        fontFamily: 'Lato',
        width: 674
      }),
      createText({
        text: 'on',
        left: 197,
        top: 725,
        fontSize: 16,
        fontFamily: 'Sofia Sans Semi Condensed',
        fontStyle: 'italic',
        fontWeight: '300',
        color: '#353535',
        width: 400
      }),
      createText({
        text: '{completion_date}',
        left: 60,
        top: 769,
        fontSize: 25,
        fontFamily: 'Lato',
        width: 674
      }),
      createText({
        text: 'John Smith',
        left: 60,
        top: 865,
        fontSize: 41,
        fontFamily: 'Great Vibes',
        width: 250
      }),
      createLine({ left: 81, top: 910, width: 214 }),
      createText({
        text: 'JOHN SMITH',
        left: 60,
        top: 910,
        fontSize: 16,
        fontFamily: 'Lato',
        width: 250,
        color: '#444545'
      }),
      createText({
        text: 'director',
        left: 60,
        top: 925,
        fontSize: 10,
        fontFamily: 'Lato',
        width: 250,
        color: '#353535'
      }),
      createText({
        text: 'Jane Doe',
        left: 484,
        top: 865,
        fontSize: 41,
        fontFamily: 'Great Vibes',
        width: 250
      }),
      createLine({ left: 499, top: 910, width: 214 }),
      createText({
        text: 'JANE DOE',
        left: 484,
        top: 910,
        fontSize: 16,
        fontFamily: 'Lato',
        width: 250,
        color: '#444545'
      }),
      createText({
        text: 'manager',
        left: 484,
        top: 925,
        fontSize: 10,
        fontFamily: 'Lato',
        width: 250,
        color: '#353535'
      })
    ],
    backgroundColor: '#fffdf9',
    backgroundImage: {
      url: '/assets/diploma-templates/backgrounds/01_background.svg',
      key: null
    }
  }
});
